import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import ProductionLineColumn from './ProductionLineColumn';
import AddProductionLine from "./AddProductionLine";
import React from "react";
import ExpandedProductionLine from "./ExpandedProductionLine";
import {useNavigate} from "react-router-dom";


const ProductionLine = () => {
    const [columns] = ProductionLineColumn();
    const navigate = useNavigate();

    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>سری تولید</Title>
                    <AddProductionLine/>

                </div>
            </ComponentCard> <ComponentCard>

            <CreatorTable columns={columns} listAddress='ProductSeries/Production-Line'  childrenColumnName='childs'
                          onDoubleClickRowHandler={(row) => {
                              navigate(`/PalletStatus?ProductSeri=${row.id}`);

                          }}


                          expandable={{
                              expandedRowRender: (row) => (

                                  <ExpandedProductionLine item={row}/>

                              ),
                          }}

            />

        </ComponentCard></div>
    );
};


export default ProductionLine;